<script>
  import { onMount } from 'svelte';
  import SwiperNav from '$lib/swiper/Nav.svelte';
  import { Navigation } from 'swiper';

  export let projects;
  export let light = false;

  let swiperEl, navPrevEl, navNextEl;

  onMount(() => {
    Object.assign(swiperEl, {
      modules: [Navigation],
      navigation: {
        prevEl: navPrevEl,
        nextEl: navNextEl,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        480: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 5,
        },
      },
    });

    swiperEl.initialize();
  });
</script>

<section class="projects-wrap text-center" class:light>
  <div class="container container--medium">
    <h2 class="projects__title tagline">{projects.title}</h2>

    <div class="projects">
      <SwiperNav bind:prev={navPrevEl} bind:next={navNextEl} />

      <swiper-container bind:this={swiperEl} init={false}>
        {#each projects.items as item}
          <swiper-slide>
            {#if item.link}
              <a class="project-item" href={item.link} target="_blank">
                <img
                  class="project-item__img"
                  src={item.logo.src}
                  width={item.logo.width}
                  height={item.logo.height}
                  alt={item.logo.alt}
                  loading="lazy"
                />
              </a>
            {:else}
              <div class="project-item">
                <img
                  class="project-item__img"
                  src={item.logo.src}
                  width={item.logo.width}
                  height={item.logo.height}
                  alt={item.logo.alt}
                  loading="lazy"
                />
              </div>
            {/if}
          </swiper-slide>
        {/each}
      </swiper-container>
    </div>

    <p class="text-small projects__note">{projects.note}</p>
  </div>
</section>

<style lang="scss">
  .projects-wrap {
    &.light {
      background-color: var(--aqua-3);
    }

    :global .swiper-nav {
      margin-top: -2.5rem;
    }
  }

  .projects {
    @include resp-min('m') {
      display: flex;
      flex-wrap: wrap;
    }

    position: relative;

    &__title {
      margin: 0 0 5rem;
    }

    &__note {
      max-width: 58rem;
      margin: 5rem auto 0;
    }

    .line-horizontal {
      width: 100%;
    }
  }

  .project-item {
    flex: 1 1 20%;

    padding: 5rem 0 4.7rem;

    display: flex;
    align-items: center;
    justify-content: center;

    aspect-ratio: 4/3;
  }
</style>
